import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader, Spinner, Alert } from "@/components/ui";
import { toast } from "sonner";
import { ActiveSubscriptionCard } from "@/components/billing/ActiveSubscriptionCard";
import { PlanCard } from "@/components/billing/PlanCard";
import { PilotBanner } from "@/components/billing/PilotBanner";
import { captureEvent } from "@/lib/analytics";

export default function Billing() {
  const [plans, setPlans] = useState(null);
  const [status, setStatus] = useState(null);
  const [busy, setBusy] = useState(null);
  const [err, setErr] = useState(null);

  const load = async () => {
    const [p, s] = await Promise.all([api.billingPlans(), api.billingStatus().catch(() => ({ status: "none" }))]);
    setPlans(p); setStatus(s);
  };
  useEffect(() => { load(); }, []);

  const checkout = async (planId) => {
    setErr(null); setBusy(planId);
    captureEvent("billing_checkout_started", { plan: planId });
    try {
      const r = await api.billingCheckout(planId);
      if (r?.url) { window.location.href = r.url; return; }
      await load();
      toast.success("Trial started");
      captureEvent("start_trial", { plan: planId, via: "local" });
    } catch (e) { setErr(e?.detail || e?.message || "Checkout failed"); }
    finally { setBusy(null); }
  };

  const cancel = async () => {
    if (!window.confirm("Cancel your subscription?")) return;
    setErr(null);
    try { await api.billingCancel(); await load(); toast.success("Subscription canceled"); }
    catch (e) { setErr(e?.detail || e?.message || "Cancel failed"); }
  };

  if (!plans || !status) return <Spinner />;
  const active = ["trialing", "active", "past_due"].includes(status.status);

  return (
    <div className="kb-fade-up">
      <PageHeader eyebrow="Plans & billing" title="Choose your plan" />

      <PilotBanner pilot={status.pilot ?? null} />

      {active && <ActiveSubscriptionCard status={status} onCancel={cancel} />}
      <Alert testid="billing-error">{err}</Alert>

      <div className="grid sm:grid-cols-2 gap-4">
        {plans.plans.map((p) => (
          <PlanCard key={p.id} plan={p} trialDays={plans.trial_days} active={active} busy={busy === p.id} onCheckout={checkout} />
        ))}
      </div>
      <p className="text-xs text-subtle text-center mt-6">No PHI stored with payments · Cancel anytime · {plans.mode} mode</p>
    </div>
  );
}
